import { string, object, array, mixed, boolean, number } from 'yup';

const schema = object({
  name: string().required('This is a required field'),
  isActive: boolean(),
  rateLimit: number()
    .typeError('Value must be a number')
    .required('This field is required')
    .min(1, 'Value must be at least 1')
    .max(180, 'Value must be at most 180'),
  allowedStudentFilters: array().min(1, 'At least one filter is required').required('This is a required field')
});

export default { create: schema, edit: schema };
